import React from 'react';
import './services.css';
import { useTranslation } from "react-i18next";
import { FaUtensils, FaCamera, FaConciergeBell, FaChair, FaBolt, FaHandsHelping } from 'react-icons/fa';

function Services() {
  const { t } = useTranslation();

  const serviceCards = [
    {
      icon: <FaChair />,
      title: 'Reception & Dining Halls',
      description: `${t('Reception_seats')}, ${t('Dining_seats')}, ${t('Bathroom')}`
    },
    {
      icon: <FaUtensils />,
      title: 'Complete Kitchen Setup',
      description: `${t('kitchen')}, ${t('Grinder')}, ${t('Stove')}`
    },
    {
      icon: <FaBolt />,
      title: 'Facility Services',
      description: `${t('Electricity')}, ${t('Generator')}, ${t('Cleaning_service')}, 2 Lifts`
    },
    {
      icon: <FaCamera />,
      title: 'Photography & Decor',
      description: `${t('Videography')}, ${t('Decoration')}, ${t('Shamiyanaa')}`
    },
    {
      icon: <FaConciergeBell />,
      title: 'Additional Amenities',
      description: `${t('Commercial_gas')}, ${t('Mineral_water')}, ${t('Ice_cream')}, ${t('Beeda')}`
    },
    {
      icon: <FaHandsHelping />,
      title: 'Other Event Services',
      description: `${t('Cooking_contact')}, ${t('Others')} ${t('extra_charges')}`
    },
  ];

  return (
    <section className='services-section' id="services-section">
      <h2 className="section-title">Our Services</h2>
      <p className="section-subtitle">
        Everything you need for a perfect event, all under one roof
      </p>
      <div className="services-grid">
        {serviceCards.map((card, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">
              {card.icon}
            </div>
            <h3 className="service-card-title">{card.title}</h3>
            <p className="service-card-desc">{card.description}</p>
          </div>
        ))}
      </div>
      <div className="services-contact">
        <p>
          {t('More_details')}<br />
          <span>Vivek +91 9448082840</span><br />
          <span>{t('Kantaraju')} +91 9740570582</span>
        </p>
      </div>
    </section>
  );
}

export default Services;
